<template>
	<div class='content'>
		<van-nav-bar
		   title="票过闸次数详情列表"
		   left-text=""
		   right-text=""
		   left-arrow
		   @click-left="onClickLeft"
		  @click-right="onClickRight"
		/>
		
	 <van-row  style="padding-bottom: 70px;" >
			<div v-for="(item,index) in Listdata" :key="index" style="padding-top: 22px;">
				 <van-row >
				  	  <van-col span="24">
				  	  	    <van-col span="24" style="padding-top: 5px; padding-bottom: 5px; padding-left: 5px;">
                      <van-col span="10" style="padding-left:10px;" >
		  	  		  		 		景点:
		  	  		  		 	</van-col>
		  	  		  		 	<van-col span="14" style="font-size: 14px;text-align: right;padding-right:10px; "  >{{item.name}}</van-col>
	  	  		  		  	</van-col>
	  	  		  		     <van-col span="24"  style="padding-top: 5px; padding-bottom: 5px; padding-left: 5px;">
                        <van-col span="12" style="margin-top:0px; padding-left:10px;" >
                          总次数:
                          </van-col>
                          <van-col span="12" style="font-size: 14px;text-align: right;padding-right:10px;">{{item.remainTimes  }}</van-col>
                       </van-col>
	  	  		  		     <van-col span="24"  style="padding-top: 5px; padding-bottom: 5px; padding-left: 5px;">
                            <van-col span="12" style="margin-top:0px;padding-left:10px;" >
                            日次数:
                        </van-col>
                        <van-col span="12" style="font-size: 14px;text-align: right;padding-right:10px;">{{item.remainTimesByDay  }}</van-col>
	  	  		  		  	 </van-col>
	  	  		  		     <van-col span="24"  style="padding-top: 5px; padding-bottom: 5px; padding-left: 5px;">
                          <van-col span="20" style="margin-top:0px;padding-left:10px;" >
                          可用时间分钟(计时票时生效):
                          </van-col>
                        <van-col span="4" style="font-size: 14px;text-align: right;padding-right:10px;">{{item.remainValidTime}} </van-col>
	  	  		  		  	</van-col>
	  	  		  		    
					  </van-col>
			    </van-row>
	 
			</div>
		</van-row>
		
	    <van-tabbar v-model="active" active-color="#FF4A53">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
		
	</div>
</template>

<script>
  export default {
  data () {
    return {
    	 isDisable_:false,
    	 disabled:"",
    	 active:1,
    	 orderID_:'',
    	 isDisable:false,
    	 numlist:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     text: '',
	     message:'',
	     isLoadingShow: true,
    	 hide:false,
         
	     finished: false,
         show: false,
         className: '',
         checked:null,
         Listdata: [],
		
         total:'0',
         result: [],
         showCalendar: false,
        
	    }
    },
    mounted(){
    	
      this.ticket_cs();
    },
     
	computed:{},
	methods: {
		ticket_cs(){
			
			let subTicketID = this.$route.query.subTicketID;;
				this.$axios({
						url: "/api/ticketZone/selectZoneParams",
						method: "get",
						params: {
							subTicketID: subTicketID
						}
					})
					.then(res => {
						console.log(res.data)
						let data =res.data 
						this.Listdata = [];
						for(const i in data) {
							this.Listdata.push({
								remainTimesByDay : data[i].remainTimesByDay  ,
								remainValidTime :  data[i].remainValidTime ,
								remainTimes : data[i].remainTimes ,
								name:data[i].name ,
							});
						}
						this.makForm=true;	
					})
				.catch(err => {
					console.log(err);
				});
			},
		
	 home(){
	    	 this.$router.push({ path: "/wx_ticketIndex" });
	    },
	    user(){
	    	 this.$router.push({ path: "/wx_ticketUser" });
	    },
		onLoad() {
	        this.loading = false;
			this.finished = true;
	       
	    },
	    onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
		onClickRight(){
			
		},
		
       
		 
	}
}
</script>

<style scoped>
   .box_visit .list i {
		color: #00B2AD;
		width: 20px;
		height: 20px;
		font-size: 15px;
		margin-left: 10px;
	}
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.box_visit .check{
		text-align: right !important;
	}
    .box_visit  .check i {
		margin-left: 0px !important;
		margin-right: 8px !important;
		margin-top:10px;
	}
	.check_code{
		display:inline-block;	
		width: 80px;
		height: 33px;
		position: relative;
		top: -2.5px;
		}
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketTicket.vue